import type { StandardFormatOptions } from "dayjs";
import Dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import jalaliday from "jalali-plugin-dayjs";
import duration from "dayjs/plugin/duration";

const reg = /(\d{4})-\d{1,2}-\d{1,2}/;

Dayjs.extend(utc);
Dayjs.extend(relativeTime);
Dayjs.extend(duration);
// dayjs.extend(isLeapYear)
Dayjs.extend(jalaliday);

Dayjs.extend((_, Dayjs) => {
  const proto = Dayjs.prototype;
  const oldParse = proto.parse;
  proto.parse = function (cfg) {
    if (cfg.date && typeof cfg.date === "string" && reg.test(cfg.date)) {
      const res = reg.exec(cfg.date);
      if (res && Number(res[1]) < 1600) cfg.jalali = true;
    }
    oldParse.bind(this)(cfg);
  };
  proto.standardFormat = function (options?: StandardFormatOptions) {
    const {
      template = "YYYY-MM-DD",
      jalali = false,
      locale = "en",
    } = options || {};
    return this.calendar(jalali ? "jalali" : "gregory")
      .locale(locale)
      .format(template);
  };
});

globalThis.dayjs = Dayjs;

export const dayjs = Dayjs;
